module.exports = __webpack_public_path__ + "img/setting.54d53468.svg";